export default {
  methods: {
    /**
     * Verifica si el restaurante tiene habilitado foodcourd_two
     * @param {Object} row - Fila de datos del restaurante/meal
     * @returns {Boolean} - true si está habilitado foodcourd_two
     */
    checkIfFoodcourdTwo(row) {
      console.log(row.is_foodcourd_two);
      // Opción 1: Si la propiedad está directamente en los datos del restaurante
      if (row && row.is_foodcourd_two === 1) {
        console.log(row);
        return true;
      }

      // Por defecto, usar la versión 1.0
      return false;
    },

    /**
     * Obtiene la URL de la receta según la versión
     * @param {Object} row - Fila de datos del restaurante/meal
     * @returns {String} - URL de la receta
     */
    getRecipeUrl(row) {
      const isFoodcourdTwo = this.checkIfFoodcourdTwo(row);
      if (isFoodcourdTwo) {
        return '/#/foodcourt/receta-v2/' + row.meal_id;
      }
      return '/#/foodcourt/receta/' + row.meal_id;
    },

    /**
     * Obtiene el texto del botón según la versión
     * @param {Object} row - Fila de datos del restaurante/meal
     * @returns {String} - Texto del botón
     */
    getRecipeButtonText(row) {
      const isFoodcourdTwo = this.checkIfFoodcourdTwo(row);
      if (isFoodcourdTwo) {
        return 'Ver Receta 2.0';
      }
      return 'Ver Receta';
    },

    /**
     * Obtiene la clase CSS del botón según la versión
     * @param {Object} row - Fila de datos del restaurante/meal
     * @returns {String} - Clase CSS del botón
     */
    getRecipeButtonClass(row) {
      const isFoodcourdTwo = this.checkIfFoodcourdTwo(row);
      if (isFoodcourdTwo) {
        return 'btn-warning'; // Color diferente para distinguir la versión 2.0
      }
      return 'btn-success';
    }
  }
}; 